// Localized strings for Checkout page
var checkoutText = {
  en: {
    title: 'Secure Checkout',
    backToCart: 'Back to cart',
    emptyCart: 'Your cart is empty',
    continueShopping: 'Continue shopping',
    contactInfo: 'Contact information',
    email: 'Email address',
    fullName: 'Full name',
    shipping: 'Shipping address',
    firstName: 'First name',
    lastName: 'Last name',
    address: 'Street address',
    apartment: 'Apartment, suite, etc. (optional)',
    city: 'City',
    state: 'State / Province',
    postal: 'Postal code',
    country: 'Country',
    payment: 'Payment',
    paymentNote: 'Pay with PayPal, Pay Later, Venmo, or credit/debit card. All payments are encrypted and processed securely by PayPal.',
    orderSummary: 'Order summary',
    subtotal: 'Subtotal',
    shippingCost: 'Shipping',
    shippingInsurance: 'Shipping insurance',
    shippingInsuranceDescription: 'If your order is lost or arrives damaged, we will send a free replacement — no questions asked.',
    noteturnerWarrantyShort: 'NoteTurner 2-Year Warranty',
    noteturnerWarrantyTitle: 'NoteTurner — 2-Year Replacement Warranty',
    noteturnerWarrantyDescription: 'Optional protection plan for your NoteTurner: one replacement per year for two years. Customer pays shipping for each replacement.',
    countryFeesDisclaimer: 'You may be responsible for additional customs duties, import taxes, or other fees dictated by your country\'s laws on delivery. Please check your country\'s import rules before purchasing.',
    total: 'Total',
    freeShipping: 'Calculated at checkout',
    placeOrder: 'Place order',
    processing: 'Processing payment…',
    digitalOnly: 'Digital products — no shipping required',
    successTitle: 'Thank you for your order! 🎺',
    successBody: 'A confirmation email has been sent to',
    orderNumber: 'Order number',
    yourDownloads: 'Your downloads (valid 72 hours, 5 downloads each):',
    backHome: 'Back to home',
    requiredField: 'Required',
    paymentFailed: 'Payment failed',
    notReady: 'Payment form is loading…',
    phone: 'Phone number',
    chooseCountry: 'Choose country',
    shippingMethod: 'Shipping method',
    tax: 'VAT (16%)',
    importTax: 'Import tax (US)',
    shippingNote: '🌍 We ship worldwide from Mexico via Correos de México. Your package will be handed over to your local postal service (USPS, La Poste, Japan Post, Royal Mail, etc.) for final delivery.',
    selectCountryFirst: 'Select your country to see shipping options',
    toneRegistryTitle: 'Register your instrument in ToneRegistry 🎺',
    toneRegistryBody: 'While you wait for your order, check out ToneRegistry — the world\'s first permanent database for instrument serial numbers. Protect your gear, deter theft, and prove ownership forever. Free to register.',
    toneRegistryCTA: 'Try ToneRegistry →',
    sameAsContact: 'Use the same name & phone for shipping',
    upsellTitle: '🎁 Add to your order — limited offer',
    upsellAdd: 'Add for',
    upsellSaving: 'save',
  },
  es: {
    title: 'Pago Seguro',
    backToCart: 'Volver al carrito',
    emptyCart: 'Tu carrito está vacío',
    continueShopping: 'Seguir comprando',
    contactInfo: 'Información de contacto',
    email: 'Correo electrónico',
    fullName: 'Nombre completo',
    shipping: 'Dirección de envío',
    firstName: 'Nombre',
    lastName: 'Apellido',
    address: 'Dirección',
    apartment: 'Apartamento, suite, etc. (opcional)',
    city: 'Ciudad',
    state: 'Estado / Provincia',
    postal: 'Código postal',
    country: 'País',
    payment: 'Pago',
    paymentNote: 'Paga con PayPal, Pay Later, Venmo o tarjeta de crédito/débito. Procesado de forma segura por PayPal.',
    orderSummary: 'Resumen del pedido',
    subtotal: 'Subtotal',
    shippingCost: 'Envío',
    shippingInsurance: 'Seguro de envío',
    shippingInsuranceDescription: 'Si tu pedido se pierde o llega dañado, te enviaremos un reemplazo gratis — sin hacer preguntas.',
    noteturnerWarrantyShort: 'Garantía NoteTurner de 2 años',
    noteturnerWarrantyTitle: 'NoteTurner — Garantía de reemplazo de 2 años',
    noteturnerWarrantyDescription: 'Plan de protección opcional para tu NoteTurner: un reemplazo por año durante dos años. El cliente paga el envío de cada reemplazo.',
    countryFeesDisclaimer: 'Puedes ser responsable de aranceles aduaneros, impuestos de importación u otras tarifas dictadas por las leyes de tu país al momento de la entrega. Por favor consulta las reglas de importación de tu país antes de comprar.',
    total: 'Total',
    freeShipping: 'Calculado al pagar',
    placeOrder: 'Realizar pedido',
    processing: 'Procesando pago…',
    digitalOnly: 'Productos digitales — sin envío',
    successTitle: '¡Gracias por tu pedido! 🎺',
    successBody: 'Hemos enviado un correo de confirmación a',
    orderNumber: 'Número de pedido',
    yourDownloads: 'Tus descargas (válidas 72 horas, 5 descargas cada una):',
    backHome: 'Volver al inicio',
    requiredField: 'Requerido',
    paymentFailed: 'Pago fallido',
    notReady: 'Cargando formulario de pago…',
    phone: 'Teléfono',
    chooseCountry: 'Elige país',
    shippingMethod: 'Método de envío',
    tax: 'IVA (16%)',
    importTax: 'Impuesto de importación (US)',
    shippingNote: '🌍 Enviamos a todo el mundo desde México con Correos de México. Tu paquete será entregado por tu correo local (USPS, La Poste, Japan Post, Royal Mail, etc.) en su tramo final.',
    selectCountryFirst: 'Selecciona tu país para ver opciones de envío',
    toneRegistryTitle: 'Registra tu instrumento en ToneRegistry 🎺',
    toneRegistryBody: 'Mientras esperas tu pedido, conoce ToneRegistry — la primera base de datos mundial permanente para números de serie de instrumentos. Protege tu equipo, disuade el robo y prueba la propiedad para siempre. Registro gratuito.',
    toneRegistryCTA: 'Conocer ToneRegistry →',
    sameAsContact: 'Usar el mismo nombre y teléfono para el envío',
    upsellTitle: '🎁 Añade a tu pedido — oferta limitada',
    upsellAdd: 'Añadir por',
    upsellSaving: 'ahorra',
  },
  ja: {
    title: '安全な決済',
    backToCart: 'カートに戻る',
    emptyCart: 'カートは空です',
    continueShopping: 'ショッピングを続ける',
    contactInfo: '連絡先情報',
    email: 'メールアドレス',
    fullName: 'お名前',
    shipping: 'お届け先住所',
    firstName: '名',
    lastName: '姓',
    address: '住所',
    apartment: 'アパート、号室など（任意）',
    city: '市区町村',
    state: '都道府県',
    postal: '郵便番号',
    country: '国',
    payment: '支払い',
    paymentNote: 'PayPal、Pay Later、Venmo、またはクレジット/デビットカードで支払えます。PayPalが安全に処理します。',
    orderSummary: 'ご注文内容',
    subtotal: '小計',
    shippingCost: '配送料',
    shippingInsurance: '配送保険',
    shippingInsuranceDescription: '商品が紛失または破損して届いた場合、無料で代替品をお送りします。',
    noteturnerWarrantyShort: 'NoteTurner 2年保証',
    noteturnerWarrantyTitle: 'NoteTurner — 2年間の交換保証',
    noteturnerWarrantyDescription: 'NoteTurnerのオプション保証プラン：2年間、年1回の交換が可能です。各交換の送料はお客様負担となります。',
    total: '合計',
    freeShipping: '決済時に計算',
    placeOrder: '注文を確定する',
    processing: '決済処理中…',
    digitalOnly: 'デジタル商品 — 配送不要',
    successTitle: 'ご注文ありがとうございます！🎺',
    successBody: '確認メールを以下のアドレスに送信しました:',
    orderNumber: '注文番号',
    yourDownloads: 'ダウンロード（72時間有効、各5回まで）:',
    backHome: 'ホームに戻る',
    requiredField: '必須',
    paymentFailed: '決済に失敗しました',
    notReady: '決済フォームを読み込み中…',
    phone: '電話番号',
    chooseCountry: '国を選択',
    shippingMethod: '配送方法',
    tax: '消費税 (16%)',
    importTax: '輸入税 (米国)',
    shippingNote: '🌍 メキシコのCorreos de Méxicoから世界中に発送します。お荷物はお住まいの国の郵便（USPS、La Poste、日本郵便、Royal Mailなど）から最終配達されます。',
    selectCountryFirst: '配送オプションを表示するには国を選択してください',
    toneRegistryTitle: 'ToneRegistryに楽器を登録 🎺',
    toneRegistryBody: 'ご注文をお待ちの間、ToneRegistryをご覧ください — 世界初の楽器シリアル番号の永続データベースです。楽器を守り、盗難を抑止し、永遠に所有権を証明します。登録は無料です。',
    toneRegistryCTA: 'ToneRegistryを試す →',
    sameAsContact: '配送先に同じ名前と電話番号を使用',
    upsellTitle: '🎁 ご注文に追加 — 期間限定オファー',
    upsellAdd: '追加',
    upsellSaving: 'お得',
    // --- auto-translated from EN (ja, May 2026) ---
    countryFeesDisclaimer: 'お届け先の国の法律により、追加の関税や輸入税、その他の手数料がかかる場合がございます。ご購入前に必ずお客様の国の輸入規則をご確認くださいませ。',
  },
  de: {
    title: 'Sicherer Checkout',
    backToCart: 'Zurück zum Warenkorb',
    emptyCart: 'Ihr Warenkorb ist leer',
    continueShopping: 'Weiter einkaufen',
    contactInfo: 'Kontaktdaten',
    email: 'E-Mail-Adresse',
    fullName: 'Vollständiger Name',
    shipping: 'Lieferadresse',
    firstName: 'Vorname',
    lastName: 'Nachname',
    address: 'Straße und Hausnummer',
    apartment: 'Wohnung, Suite usw. (optional)',
    city: 'Stadt',
    state: 'Bundesland',
    postal: 'PLZ',
    country: 'Land',
    payment: 'Zahlung',
    paymentNote: 'Bezahlen Sie mit PayPal, Pay Later, Venmo oder Kredit-/Debitkarte. Alle Zahlungen werden sicher von PayPal verarbeitet.',
    orderSummary: 'Bestellübersicht',
    subtotal: 'Zwischensumme',
    shippingCost: 'Versand',
    shippingInsurance: 'Versandversicherung',
    shippingInsuranceDescription: 'Sollte Ihre Bestellung verloren gehen oder beschädigt ankommen, senden wir Ihnen kostenlos Ersatz — ohne Wenn und Aber.',
    noteturnerWarrantyShort: 'NoteTurner 2-Jahres-Garantie',
    noteturnerWarrantyTitle: 'NoteTurner — 2-Jahres-Ersatzgarantie',
    noteturnerWarrantyDescription: 'Optionaler Schutzplan für Ihren NoteTurner: ein Ersatz pro Jahr über zwei Jahre. Der Kunde übernimmt die Versandkosten für jeden Ersatz.',
    total: 'Gesamt',
    freeShipping: 'Wird beim Checkout berechnet',
    placeOrder: 'Bestellung aufgeben',
    processing: 'Zahlung wird verarbeitet…',
    digitalOnly: 'Digitale Produkte — kein Versand',
    successTitle: 'Vielen Dank für Ihre Bestellung! 🎺',
    successBody: 'Eine Bestätigungs-E-Mail wurde gesendet an',
    orderNumber: 'Bestellnummer',
    yourDownloads: 'Ihre Downloads (72 Stunden gültig, 5 Downloads pro Link):',
    backHome: 'Zur Startseite',
    requiredField: 'Erforderlich',
    paymentFailed: 'Zahlung fehlgeschlagen',
    notReady: 'Zahlungsformular wird geladen…',
    phone: 'Telefonnummer',
    chooseCountry: 'Land wählen',
    shippingMethod: 'Versandart',
    tax: 'MwSt. (16%)',
    importTax: 'Einfuhrsteuer (USA)',
    shippingNote: '🌍 Wir versenden weltweit aus Mexiko über Correos de México. Ihr Paket wird an Ihren lokalen Postdienst (USPS, La Poste, Japan Post, Royal Mail usw.) zur Endzustellung übergeben.',
    selectCountryFirst: 'Wählen Sie Ihr Land, um Versandoptionen anzuzeigen',
    toneRegistryTitle: 'Registrieren Sie Ihr Instrument bei ToneRegistry 🎺',
    toneRegistryBody: 'Während Sie auf Ihre Bestellung warten, schauen Sie sich ToneRegistry an — die weltweit erste permanente Datenbank für Instrumenten-Seriennummern. Schützen Sie Ihre Ausrüstung, beugen Sie Diebstahl vor und beweisen Sie Ihr Eigentum für immer. Kostenlose Registrierung.',
    toneRegistryCTA: 'ToneRegistry ausprobieren →',
    sameAsContact: 'Denselben Namen und dieselbe Telefonnummer für den Versand verwenden',
    upsellTitle: '🎁 Zur Bestellung hinzufügen — Sonderangebot',
    upsellAdd: 'Hinzufügen für',
    upsellSaving: 'sparen',
    // --- auto-translated from EN (de, May 2026) ---
    countryFeesDisclaimer: 'Möglicherweise sind Sie für zusätzliche Zollgebühren, Einfuhrsteuern oder andere Gebühren verantwortlich, die durch die Gesetze Ihres Landes bei der Lieferung vorgeschrieben sind. Bitte prüfen Sie vor dem Kauf die Einfuhrbestimmungen Ihres Landes.',
  },
  fr: {
    title: 'Paiement sécurisé',
    backToCart: 'Retour au panier',
    emptyCart: 'Votre panier est vide',
    continueShopping: 'Continuer mes achats',
    contactInfo: 'Coordonnées',
    email: 'Adresse e-mail',
    fullName: 'Nom complet',
    shipping: 'Adresse de livraison',
    firstName: 'Prénom',
    lastName: 'Nom',
    address: 'Adresse',
    apartment: 'Appartement, suite, etc. (facultatif)',
    city: 'Ville',
    state: 'Région',
    postal: 'Code postal',
    country: 'Pays',
    payment: 'Paiement',
    paymentNote: "Payez avec PayPal, Pay Later, Venmo ou carte de crédit/débit. Tous les paiements sont traités en toute sécurité par PayPal.",
    orderSummary: 'Récapitulatif',
    subtotal: 'Sous-total',
    shippingCost: 'Livraison',
    shippingInsurance: 'Assurance de livraison',
    shippingInsuranceDescription: 'Si votre commande est perdue ou arrive endommagée, nous vous enverrons un remplacement gratuit — sans condition.',
    total: 'Total',
    freeShipping: 'Calculé au paiement',
    placeOrder: 'Passer la commande',
    processing: 'Traitement du paiement…',
    digitalOnly: 'Produits numériques — pas de livraison',
    successTitle: 'Merci pour votre commande ! 🎺',
    successBody: 'Un e-mail de confirmation a été envoyé à',
    orderNumber: 'N° de commande',
    yourDownloads: 'Vos téléchargements (valides 72h, 5 téléchargements chacun):',
    backHome: "Retour à l'accueil",
    requiredField: 'Obligatoire',
    paymentFailed: 'Échec du paiement',
    notReady: 'Chargement du formulaire de paiement…',
    phone: 'Téléphone',
    chooseCountry: 'Choisir un pays',
    shippingMethod: 'Mode de livraison',
    tax: 'TVA (16%)',
    importTax: "Taxe d'importation (US)",
    shippingNote: '🌍 Nous expédions dans le monde entier depuis le Mexique via Correos de México. Votre colis sera remis à votre service postal local (USPS, La Poste, Japan Post, Royal Mail, etc.) pour la livraison finale.',
    selectCountryFirst: 'Sélectionnez votre pays pour voir les options de livraison',
    toneRegistryTitle: 'Enregistrez votre instrument sur ToneRegistry 🎺',
    toneRegistryBody: 'En attendant votre commande, découvrez ToneRegistry — la première base de données mondiale permanente pour les numéros de série d\'instruments. Protégez votre équipement, dissuadez le vol et prouvez la propriété pour toujours. Inscription gratuite.',
    toneRegistryCTA: 'Essayer ToneRegistry →',
    sameAsContact: 'Utiliser le même nom et téléphone pour la livraison',
    upsellTitle: '🎁 Ajoutez à votre commande — offre limitée',
    upsellAdd: 'Ajouter pour',
    upsellSaving: 'économisez',
    // --- auto-translated from EN (fr, May 2026) ---
    noteturnerWarrantyShort: 'Garantie NoteTurner de 2 ans',
    noteturnerWarrantyTitle: 'NoteTurner — Garantie de remplacement de 2 ans',
    noteturnerWarrantyDescription: 'Protection optionnelle pour votre NoteTurner : un remplacement par an pendant deux ans. Le client prend en charge les frais d’expédition pour chaque remplacement.',
    countryFeesDisclaimer: 'Vous pourriez être responsable de droits de douane supplémentaires, taxes d’importation ou autres frais selon la législation de votre pays au moment de la livraison. Veuillez vérifier les règles d’importation de votre pays avant d’acheter.',
  },
  it: {
    title: 'Pagamento sicuro',
    backToCart: 'Torna al carrello',
    emptyCart: 'Il tuo carrello è vuoto',
    continueShopping: 'Continua lo shopping',
    contactInfo: 'Informazioni di contatto',
    email: 'Indirizzo email',
    fullName: 'Nome completo',
    shipping: 'Indirizzo di spedizione',
    firstName: 'Nome',
    lastName: 'Cognome',
    address: 'Indirizzo',
    apartment: 'Appartamento, interno, ecc. (opzionale)',
    city: 'Città',
    state: 'Regione',
    postal: 'CAP',
    country: 'Paese',
    payment: 'Pagamento',
    paymentNote: 'Paga con PayPal, Pay Later, Venmo o carta di credito/debito. Tutti i pagamenti sono elaborati in modo sicuro da PayPal.',
    orderSummary: 'Riepilogo ordine',
    subtotal: 'Subtotale',
    shippingCost: 'Spedizione',
    shippingInsurance: 'Assicurazione di spedizione',
    shippingInsuranceDescription: 'Se il tuo ordine viene smarrito o arriva danneggiato, ti invieremo gratuitamente un articolo sostitutivo — senza domande.',
    noteturnerWarrantyShort: 'Garanzia NoteTurner di 2 anni',
    noteturnerWarrantyTitle: 'NoteTurner — Garanzia di sostituzione di 2 anni',
    noteturnerWarrantyDescription: 'Piano di protezione opzionale per il tuo NoteTurner: una sostituzione all\'anno per due anni. Il cliente paga la spedizione per ogni sostituzione.',
    total: 'Totale',
    freeShipping: 'Calcolato al pagamento',
    placeOrder: 'Conferma ordine',
    processing: 'Elaborazione pagamento…',
    digitalOnly: 'Prodotti digitali — nessuna spedizione',
    successTitle: 'Grazie per il tuo ordine! 🎺',
    successBody: 'Email di conferma inviata a',
    orderNumber: 'Numero ordine',
    yourDownloads: 'I tuoi download (validi 72 ore, 5 download ciascuno):',
    backHome: 'Torna alla home',
    requiredField: 'Obbligatorio',
    paymentFailed: 'Pagamento fallito',
    notReady: 'Caricamento modulo di pagamento…',
    phone: 'Telefono',
    chooseCountry: 'Scegli paese',
    shippingMethod: 'Metodo di spedizione',
    tax: 'IVA (16%)',
    importTax: 'Tassa di importazione (US)',
    shippingNote: '🌍 Spediamo in tutto il mondo dal Messico tramite Correos de México. Il pacco sarà consegnato dal servizio postale locale (USPS, La Poste, Japan Post, Royal Mail, ecc.) per la consegna finale.',
    selectCountryFirst: 'Seleziona il tuo paese per vedere le opzioni di spedizione',
    toneRegistryTitle: 'Registra il tuo strumento su ToneRegistry 🎺',
    toneRegistryBody: 'In attesa del tuo ordine, scopri ToneRegistry — il primo database permanente al mondo per i numeri di serie degli strumenti. Proteggi la tua attrezzatura, scoraggia i furti e dimostra la proprietà per sempre. Registrazione gratuita.',
    toneRegistryCTA: 'Prova ToneRegistry →',
    sameAsContact: 'Usa lo stesso nome e telefono per la spedizione',
    upsellTitle: '🎁 Aggiungi al tuo ordine — offerta limitata',
    upsellAdd: 'Aggiungi a',
    upsellSaving: 'risparmia',
    // --- auto-translated from EN (it, May 2026) ---
    countryFeesDisclaimer: 'Potrebbe essere responsabile di dazi doganali aggiuntivi, tasse di importazione o altre spese dettate dalle leggi del Suo paese alla consegna. La preghiamo di controllare le normative di importazione del Suo paese prima di effettuare l\'acquisto.',
  },
  uk: {
    title: 'Оформлення замовлення',
    contact: 'Контактна інформація',
    email: 'Електронна пошта',
    fullName: 'Повне ім\'я',
    payment: 'Спосіб оплати',
    creditCard: 'Кредитна або дебетова картка',
    paypal: 'PayPal',
    shipping: 'Адреса доставки',
    street: 'Вулиця',
    city: 'Місто',
    region: 'Область',
    postalCode: 'Поштовий індекс',
    country: 'Країна',
    orderSummary: 'Підсумок замовлення',
    subtotal: 'Проміжна сума',
    shippingCost: 'Доставка',
    shippingInsurance: 'Страхування доставки',
    shippingInsuranceDescription: 'Якщо ваше замовлення буде втрачено або прибуде пошкодженим, ми безкоштовно надішлемо заміну — без жодних питань.',
    noteturnerWarrantyShort: 'Гарантія NoteTurner на 2 роки',
    noteturnerWarrantyTitle: 'NoteTurner — 2-річна гарантія заміни',
    noteturnerWarrantyDescription: 'Додатковий план захисту для вашого NoteTurner: одна заміна на рік протягом двох років. Покупець оплачує доставку кожної заміни.',
    total: 'Всього',
    placeOrder: 'Розмістити замовлення',
    processing: 'Обробка...',
    digital: '📥 Цифровий товар — миттєве завантаження після оплати',
    physicalAndDigital: 'Цей кошик містить як фізичні, так і цифрові товари. Доставка стосується лише фізичних товарів.',
    notes: 'Примітки до замовлення (необов\'язково)',
    notesPlaceholder: 'Особливі інструкції, переваги доставки...',
    success: 'Замовлення підтверджено!',
    successMessage: 'Дякуємо за покупку. Ви отримаєте підтвердження на пошту.',
    yourDownloads: 'Ваші завантаження (дійсні 72 години, по 5 завантажень кожне):',
    backHome: 'Повернутися на головну',
    requiredField: 'Обов\'язково',
    paymentFailed: 'Помилка оплати',
    notReady: 'Завантаження форми оплати…',
    phone: 'Телефон',
    chooseCountry: 'Оберіть країну',
    shippingMethod: 'Спосіб доставки',
    tax: 'Податок',
    importTax: 'Імпортний податок (США)',
    shippingNote: '🌍 Ми відправляємо по всьому світу з Мексики через Correos de México. Місцева пошта (Укрпошта, USPS, La Poste, Japan Post тощо) доставить ваше замовлення.',
    selectCountryFirst: 'Виберіть свою країну, щоб побачити варіанти доставки',
    toneRegistryTitle: 'Зареєструйте свій інструмент у ToneRegistry 🎺',
    toneRegistryBody: 'Поки чекаєте на замовлення, ознайомтеся з ToneRegistry — першою у світі постійною базою даних серійних номерів інструментів. Захистіть своє обладнання, запобігайте крадіжкам і доведіть право власності назавжди. Реєстрація безкоштовна.',
    toneRegistryCTA: 'Перейти до ToneRegistry →',
    sameAsContact: 'Використати те саме ім\'я та телефон для доставки',
    upsellTitle: '🎁 Додати до замовлення — обмежена пропозиція',
    upsellAdd: 'Додати до',
    upsellSaving: 'економія',
    discount: 'Знижка',
    discountPlaceholder: 'Промокод',
    apply: 'Застосувати',
    discountApplied: 'Знижку застосовано',
    discountCode: 'Код',
    remove: 'Видалити',
    // --- auto-translated from EN (May 2026) ---
    backToCart: 'Повернутися до кошика',
    emptyCart: 'Ваш кошик порожній',
    continueShopping: 'Продовжити покупки',
    contactInfo: 'Контактна інформація',
    firstName: 'Ім\'я',
    lastName: 'Прізвище',
    address: 'Адреса вулиці',
    apartment: 'Квартира, офіс тощо (необов’язково)',
    state: 'Штат / Область',
    postal: 'Поштовий індекс',
    paymentNote: 'Оплачуйте через PayPal, Pay Later, Venmo або кредитною/дебетовою карткою. Всі платежі зашифровані та безпечно обробляються PayPal.',
    countryFeesDisclaimer: 'Ви можете бути відповідальними за додаткові митні збори, імпортні податки або інші платежі згідно з законами вашої країни при доставці. Будь ласка, перевірте імпортні правила вашої країни перед покупкою.',
    freeShipping: 'Розраховується при оформленні замовлення',
    digitalOnly: 'Цифрові продукти — доставка не потрібна',
    successTitle: 'Дякуємо за ваше замовлення! 🎺',
    successBody: 'Підтвердження надіслано на електронну пошту',
    orderNumber: 'Номер замовлення',
  },
};

export default checkoutText;
